import { Button, Empty, Flex, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import UploadedFileCarousel from '@/components/general/UploadFile/UploadedFileCarousel';
import UploadedFileList from '@/components/general/UploadFile/UploadedFileList';
import UploadFileComponent from '@/components/general/UploadFile/UploadFile';
import { useUserContext } from '@/contexts/UserContext';
import FileData from '@/model/General/FileData';
import { USER_WORK_AREA } from '@/model/General/UserWorkArea';
import { PACKAGE_STATES } from '@/model/Logistic/PackageStates';
import { Reception } from '@/model/Logistic/Reception/Reception';
import { useRepositoriesContext } from '@/repositories/RepositoriesContext';

interface ReceptionShowFilesProps {
  record?: Reception;
}

const ReceptionShowFiles = (props: ReceptionShowFilesProps) => {
  const { t } = useTranslation();
  const { userWorkArea } = useUserContext();
  const { record } = props;
  const [packageFiles, setPackageFiles] = useState<FileData[]>([]);
  const [uploadFiles, setUploadFiles] = useState<FileData[]>([]);
  const [openModal, setOpenModal] = useState(false);
  const { receptionRepository } = useRepositoriesContext();

  useEffect(() => {
    if (record?.photos) {
      const fileList = record.photos.map(fileData => {
        return new FileData({
          id: fileData.id,
          title: fileData.description,
          file: fileData.photo,
        });
      });

      setPackageFiles(fileList);
    }
  }, [record?.photos]);

  return (
    <Flex vertical gap={16} align="flex-end">
      {packageFiles.length > 0 ? (
        <UploadedFileCarousel
          fileList={packageFiles}
          setFileList={setPackageFiles}
          canRemove={false}
        />
      ) : (
        <Empty style={{ width: '100%' }} description={t('No hay fotos cargadas')} />
      )}
      {record?.status == PACKAGE_STATES.RECIBIDO && userWorkArea == USER_WORK_AREA.LOGISTICS && (
        <>
          <Button
            style={{ width: 'fit-content', margin: '0 24px' }}
            type="primary"
            onClick={() => setOpenModal(true)}>
            {t('Cargar archivos')}
          </Button>

          <Modal
            title={t('Cargar archivos')}
            open={openModal}
            onCancel={() => {
              setOpenModal(false);
              setUploadFiles([]);
            }}
            okText={t('Cargar archivos')}
            cancelText={t('Cancelar')}
            onOk={() => {
              Modal.confirm({
                title: t('¿Estás seguro de que deseas cargar estos archivos?'),
                content: t('Esta acción no se puede deshacer'),
                okText: t('Sí'),
                okType: 'primary',
                cancelText: t('No'),
                onOk: () => {
                  if (!record?.id) {
                    setOpenModal(false);
                    setUploadFiles([]);

                    return;
                  }

                  void receptionRepository.saveFiles(uploadFiles, record.id).then(() => {
                    setPackageFiles(prev => [...prev, ...uploadFiles]);
                    setUploadFiles([]);
                    setOpenModal(false);
                  });
                },
              });

              // Refresca la UI agregando los nuevos archivos al carrusel
            }}>
            <UploadFileComponent fileList={uploadFiles} setFileList={setUploadFiles} />
            {uploadFiles.length > 0 && (
              <div style={{ marginTop: 16 }}>
                <UploadedFileList fileList={uploadFiles} setFileList={setUploadFiles} />
              </div>
            )}
          </Modal>
        </>
      )}
    </Flex>
  );
};

export default ReceptionShowFiles;
